import React from 'react'
import { connect } from 'react-redux'
import { useParams, useNavigate } from 'react-router'
import { UNSAFE_NavigationContext as NavigationContext } from 'react-router-dom'
import { Box } from '@mui/material'
import { sendWs, LEAVE } from '../lib/send'
import { confirmLeaveRoom } from '../lib/dialog'
import { rxLeave } from '../lib/rx_subject'
import Grid from './Grid'
import Dialogs from './dialogs/Dialogs'
import CommonDialogs from '../dialogs/Dialogs'

const Root = ({ roomNo }) => {
  const params = useParams()
  const navigate = useNavigate()
  const { navigator } = React.useContext(NavigationContext)

  const unblock = React.useRef(null)

  React.useEffect(() => { document.title = `Yqui | Room${roomNo}` }, [roomNo])

  React.useEffect(() => {
    const subscription = rxLeave.subscribe(cause => {
      if (cause === 'normal') {
        unblock.current()
        navigate('/')
      } else if (cause === 'missingRoom') {
        unblock.current()
        navigate('/', { state: { roomNo: parseInt(params.roomNo) } })
      }
    })

    return () => {
      subscription.unsubscribe()
    }
  }, [navigate, params.roomNo])

  React.useEffect(() => {
    const reload = () => {
      unblock.current()
    }
    window.addEventListener('beforeunload', reload)

    unblock.current = navigator.block(tx => {
      confirmLeaveRoom(() => sendWs(LEAVE))
    })

    return () => {
      unblock.current()
      window.removeEventListener('beforeunload', reload)
    }
  }, [navigator])

  React.useEffect(() => {
    if (roomNo === null) {
      rxLeave.next('missingRoom')
    }
  }, [roomNo])

  return (
    <Box className="room">
      <Grid />
      <Dialogs />
      <CommonDialogs />
    </Box>
  )
}

export default connect(
  state => ({
    roomNo: state.roomNo
  })
)(Root)
